/**
 * Tokens compartidos del semáforo de riesgo PLD. Único diccionario para TODAS las
 * pantallas (Cliente360, Perfil 360, Solicitud, Prospecto, Dashboard). Antes vivía
 * duplicado en 4 archivos con nombres distintos (RIESGO_TONE, GRADO_TONE, NIVEL_TONE,
 * SEM). Cambio de branding: tocar solo aquí.
 *
 * Convención: mayúscula inicial para el nivel HUMANO ("Alto/Medio/Bajo") y minúscula
 * para el nivel de subvariable ("alto/medio/bajo") — coincide con la salida del motor.
 */
import { ShieldCheck, ShieldAlert, ShieldX } from "lucide-react";

// Nivel humano (Alto/Medio/Bajo) usado en badges de titular y semáforos.
export const GRADO_TONE = {
  Alto:  "bg-red-100 text-red-700 border-red-200",
  Medio: "bg-amber-100 text-amber-700 border-amber-200",
  Bajo:  "bg-emerald-100 text-emerald-700 border-emerald-200",
};

// Nivel subvariable (alto/medio/bajo) usado dentro del breakdown por factor.
export const NIVEL_TONE = {
  alto:  "bg-red-100 text-red-700 border-red-200",
  medio: "bg-amber-100 text-amber-700 border-amber-200",
  bajo:  "bg-emerald-100 text-emerald-700 border-emerald-200",
};

// Semáforo consolidado con icono (usado en la caja del grado consolidado).
export const GRADO_SEMAFORO = {
  Alto:  { cls: "border-red-200 bg-red-50 text-red-800",         Icon: ShieldX },
  Medio: { cls: "border-amber-200 bg-amber-50 text-amber-800",   Icon: ShieldAlert },
  Bajo:  { cls: "border-emerald-200 bg-emerald-50 text-emerald-800", Icon: ShieldCheck },
};

// Semáforo por color-nombre (rojo/amarillo/verde) que emite el motor (`res.semaforo`).
export const SEM_POR_COLOR = {
  verde:    { label: "VERDE — Diligencia simplificada",              cls: "border-emerald-200 bg-emerald-50 text-emerald-800", Icon: ShieldCheck },
  amarillo: { label: "AMARILLO — Diligencia estándar reforzada",     cls: "border-amber-200 bg-amber-50 text-amber-800",       Icon: ShieldAlert },
  rojo:     { label: "ROJO — Debida diligencia REFORZADA + autorización del OC", cls: "border-red-200 bg-red-50 text-red-800", Icon: ShieldX },
};

export const NIVEL_LBL = { alto: "Alto", medio: "Medio", bajo: "Bajo" };
export const SIN_DATO_TONE = "bg-slate-100 text-slate-500 border-slate-200";

export const MOTIVO_LABEL = {
  matriz: "Grado ALTO por matriz EBR (5 factores)",
  pep: "Persona Expuesta Políticamente (PEP)",
  lista_potencial: "Coincidencia potencial en lista crítica",
  lista_confirmada_lpb: "Coincidencia CONFIRMADA en LPB",
};
